import axios from "axios";
import * as Breadcrumbs from '../monitoring/breadcrumbs';
import Cookies from 'js-cookie';

import { persistor } from '../services/store/store';
import { FCM_TOKEN_STORAGE_KEY, FCM_TOKEN_SAVED_AT_KEY } from '../firebase';

const Axios = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL
});

Axios.interceptors.request.use(
	(config) => {
		const token = Cookies.get("authToken");

		config.headers["Accept"] = "application/json";
		// config.headers["Content-Type"] = "application/json";

		if (token) {
			config.headers["Authorization"] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

/**
 * Record "POST /api/thing -> 500" on the error trail. Endpoint + status only —
 * request/response bodies are never touched. Best-effort; never throws.
 */
function recordApiBreadcrumb(config, status) {
	try {
		if (!config) return;
		const method = String(config.method || 'get').toUpperCase();
		Breadcrumbs.api(`${method} ${config.url || ''} -> ${status}`);
	} catch (_) {
		/* never break a request */
	}
}

Axios.interceptors.response.use(
	(response) => {
		recordApiBreadcrumb(response?.config, response?.status);
		return response
	},
	(error) => {
		recordApiBreadcrumb(error?.config, error?.response?.status || 'network-error');
		if (error?.response?.status === 401) {
			Cookies.remove('authToken')
			Cookies.remove('verified')
			if (typeof localStorage !== 'undefined') {
				localStorage.removeItem(FCM_TOKEN_STORAGE_KEY);
				localStorage.removeItem(FCM_TOKEN_SAVED_AT_KEY);
			}
			persistor.purge()
			window.location.href = '/'
		} else if (error?.response?.data?.status === 'unauthorised_otp' && error?.response?.status === 404) {
			window.location.href = '/verify-otp'
		}
		return Promise.reject(error);
	}
);

export default Axios;
